import { Responsive } from 'react-grid-layout'
import { constants } from './constants'

export const getCurrentBreakpoint = () => {
    return Responsive.utils.getBreakpointFromWidth(
        { lg: 1200, md: 992, sm: 768 },
        window.innerWidth
    )
}

export const generateLayout = (items) => {
    return {
        sm: items.map((item, i) => {
            const y = Math.ceil(Math.random() * 4) + 1
            const itemType = item.type || constants.toolsTypes.PAGE_SECTION

            return {
                ...item,
                x: 0,
                y: Math.floor(i / 6) * y,
                w: 12,
                h: itemType.height,
                i: item.id,
                type: item.type,
            }
        }),
        md: items.map((item, i) => {
            const y = Math.ceil(Math.random() * 4) + 1
            const itemType = item.type || constants.toolsTypes.PAGE_SECTION

            return {
                ...item,
                x: 0,
                y: Math.floor(i / 6) * y,
                w: 12,
                h: itemType.height,
                i: item.id,
                type: item.type,
            }
        }),
        lg: items.map((item, i) => {
            const y = Math.ceil(Math.random() * 4) + 1
            const itemType = item.type || constants.toolsTypes.PAGE_SECTION

            return {
                ...item,
                x: 0,
                y: Math.floor(i / 6) * y,
                w: 12,
                h: itemType.height,
                i: item.id,
                type: item.type,
            }
        }),
    }
}

export const boxIntersect = (box1, box2) => {
    return (
        Math.max(box1.x, box2.x) < Math.min(box1.x + box1.w, box2.x + box2.w) &&
        Math.max(box1.y, box2.y) < Math.min(box1.y + box1.h, box2.y + box2.h)
    )
}

export const bfs = (items, newItem) => {
    const q = [newItem]
    const newLayouts = [newItem]
    const visited = {}
    while (q.length) {
        for (let size = q.length; size > 0; --size) {
            const it = q.shift()
            for (let item of items) {
                if (boxIntersect(item, it) && !visited[item.i]) {
                    visited[item.i] = true
                    const pushedItem = { ...item, y: it.y + it.h }
                    q.push(pushedItem)
                    newLayouts.push(pushedItem)
                }
            }
        }
    }
    for (let item of items) {
        if (!visited[item.i]) {
            newLayouts.push(item)
        }
    }
    return newLayouts
}

export const hexToRgb = (hex: string = ''): string => {
    let hexValue = hex
    const hexValueParts = hex.split('#')
    if (hexValueParts.length > 1 && hexValueParts[1].length === 3) {
        hexValue = hexValueParts[0] + hexValueParts[1] + hexValueParts[1]
    }
    return `${parseInt(hexValue.slice(1, 3), 16)}, ${parseInt(
        hexValue.slice(3, 5),
        16
    )}, ${parseInt(hexValue.slice(5, 7), 16)}`
}
